import { Component, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// export interface FoodNode {
//   name: string;
//   children?: FoodNode[];
// }

// export interface Food {
//   value: string;
//   viewValue: string;
// }

// const TREE_DATA: FoodNode[] = [

//    {
//   name: 'User Management',
//   children: [
//     {
//       name: 'Create User',
//       children: [
//         {name: 'New User'},
//         {name: 'Create Patient'},
//         {name: 'Edit Patient'},
//       ]
//     }, {
//       name: 'Menu',
//       children: [
//         {name: 'Home'},
//         {name: 'Schedule'},
//         {name: 'Patient Chart'},
//         {name: 'Messages'},
//         {name: 'Reports'},
//         {name: 'Admin'},
//       ]
//     },
//   ]
// },

// ];


// const TREE_DATA1: FoodNode[] = [

//   {
//  name: 'User Management1',
//  children: [
//    {
//      name: 'Create User',
//      children: [
//        {name: 'New User'},
//        {name: 'Create Patient'},
//        {name: 'Edit Patient'},
//      ]
//    }, {
//      name: 'Menu',
//      children: [
//        {name: 'Home'},
//        {name: 'Schedule'},
//        {name: 'Patient Chart'},
//        {name: 'Messages'},
//        {name: 'Reports'},
//        {name: 'Admin'},
//      ]
//    },
//  ]
// },

// ];

// export interface PeriodicElement {
//   Select: string;
//   description: string;
//   datasource1: FoodNode[];

// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   { Select: '', description: '', datasource1: TREE_DATA},
//   { Select: '', description: '', datasource1: TREE_DATA1},
// ];

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})

export class RoleComponent implements OnInit {

  displayedColumns: string[] = ['Select', 'description'];

  // dataSource = ELEMENT_DATA;

  // treeControl = new NestedTreeControl<FoodNode>(node => node.children);

  // treeControls = new NestedTreeControl<FoodNode>(node => node.children);

  // datasource1 = new MatTreeNestedDataSource<FoodNode>();

  // datasource2 = new MatTreeNestedDataSource<FoodNode>();

  // foods: Food[] = [
  //   { value: 'steak-0', viewValue: 'Steak' },
  //   { value: 'pizza-1', viewValue: 'Pizza' },
  //   { value: 'tacos-2', viewValue: 'Tacos' }
  // ];

  constructor(private formBuilder: FormBuilder) {

  }

  roleForm: FormGroup;
  submitted = false;

  //hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  ngOnInit() {
    this.roleForm = this.formBuilder.group({
      rolenam: [''],
    });
  }

}
